<div class="qrcode-dialog__container" *ngIf="data.qrcodeValue">
  <img src="/assets/images/logo-takao-white.png" alt="Logo Takao" class="logo" />
  <qrcode [qrdata]="data.qrcodeValue" [width]="512" [errorCorrectionLevel]="'M'" elementType="img" [margin]="1" colorDark="#FF0000ff"></qrcode>
  <button *ngIf="showRegisterButton" mat-raised-button color="warn" (click)="onNewRegistrationClick()">Novo Cadastro</button>
</div>
